/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Objective result settled before the triggering task is finalized.
 */
export type EmployeeExecutionObjectiveSettlement = {
    /**
     * Terminal objective outcome to persist after task finalization succeeds.
     */
    outcome: EmployeeExecutionObjectiveSettlement.outcome;
    /**
     * ISO timestamp when the objective work settled.
     */
    settledAt: string;
};
export namespace EmployeeExecutionObjectiveSettlement {
    /**
     * Terminal objective outcome to persist after task finalization succeeds.
     */
    export enum outcome {
        ACHIEVED = 'achieved',
        CANCELLED = 'cancelled',
    }
}

